import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-275a3bcb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "page-card" }
const _hoisted_5 = { class: "dc-card-header" }
const _hoisted_6 = { class: "dc-card-header-defaut" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "访客计划", -1))
const _hoisted_9 = { class: "dc-card-header-defaut-subtitle" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paddingLine" }, null, -1))
const _hoisted_11 = { class: "dc-card-header" }
const _hoisted_12 = { class: "dc-card-header-defaut" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "商机", -1))
const _hoisted_15 = { class: "dc-card-header-defaut-subtitle" }

import { ref, reactive, computed, onMounted, watch, PropType, onActivated, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import Editor from '@/components/Editor'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import UploadFile from '@/components/UploadFile'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import BusinessForm from '@/views/gucangSales/chanceManage/business/components/BusinessForm.vue'
import AlarmList from './alarmList.vue'
import VisitorProgramForm from '../../components/VisitorProgramForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { signInRecordListByCosId, listByParamCodes } from '@/api/common'
import {
  followRecordsAddByMess,
  followRecordsAddOrUpdate,
  followRecordsDetail,
  followRecordsDate
  // visitorProgramDetail
} from '@/api/gucangSales/followUpManage'
import type { Rule } from 'ant-design-vue/es/form'
import type { FbuFollowUpRecordEdit } from '@/typings/api/followUpManage'
import { DcMessage, DcConfirm, message } from '@dc-platform/dc-components'
import BusinessName from '@/components/BusinessName/index.vue'
import { cloneDeep } from 'lodash-es'
import dayjs, { Dayjs } from 'dayjs'
import { selectForNumberValidate } from '@/utils/validate'
import { MessageOutlined, EnvironmentOutlined } from '@ant-design/icons-vue'
import { paramCodesDataFilter } from '@/utils/index'
import { potentialArchive } from '@/api/gucangSales/customerCenter'
import router from '@/router'
import { Modal as AModal } from 'ant-design-vue/lib/components'

const __default__ = { name: 'BaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object as PropType<FbuFollowUpRecordEdit>
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  view: {
    type: Boolean
  },
  hideOk: {
    type: Boolean
  },
  archiveIds: {
    type: Array
  }
},
  emits: ['getDetail'],
  setup(__props, { emit: __emit }) {

const route = useRoute()
const props = __props
const editorPlaceholder =
  '1. 过程<br />2. 结果<br />3. 后续<br />4.具体原因<br />5.处理方法<br />6.遇到得问题及需要得帮助 '
const signInListOptions = ref()
const baseFormRef = ref()
const saleChanceFormRef = ref()
const visitorProgramFormRef = ref()
const alarmListFromRef = ref()

const form = ref<any>({
  saleChance: {},
  visitPlanList: {}
})
const resetValue = ref<FbuFollowUpRecordEdit>({
  saleChance: {},
  visitPlanList: {}
})
const hasSaleChance = ref(false)
const hasplay = ref(false)
const loading = ref(false)
const startDate = ref(dayjs(new Date()).subtract(3, 'day').endOf('day'))
const getSignInList = async () => {
  try {
    const startTime = dayjs(form.value.startTime).format('YYYY/MM/DD') + ' 00:00:00'
    const endTime = dayjs(form.value.startTime).format('YYYY/MM/DD') + ' 23:59:59'

    const res: any = await signInRecordListByCosId({ cosId: form.value.followRefId, signInId: form.value.signInId, startTime: startTime, endTime: endTime })
    signInListOptions.value = res.data
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}
const paramCodeData = ref<{
  fbu_follow_mode: []
  fbu_follow_purpose: []
}>({
  fbu_follow_mode: [], // 拜访方式
  fbu_follow_purpose: [] // 访客目的
})
const followUpOptions = reactive<{
  contactList: any[]
  saleChanceList: any[]
  visitPlanList: any[]
}>({
  contactList: [],
  saleChanceList: [],
  visitPlanList: []
})
const disabledDate = (current: Dayjs) => {
  return current > dayjs(new Date()) || current < startDate.value
}
// 商机必填校验
const chanceIdRequired = computed(() => {
  if (form.value.fbuPurposeTxt === '处理异常' || form.value.fbuPurposeTxt === '客情维护') {
    return false
  }
  if (form.value.fbuPurposeTxt === '深耕商机') {
    return true
  }
  if (!saleChanceData.value || !saleChanceData.value.length) {
    return false
  }
  return true
})
// 有一二级异动信息存在时，目的只能选择【处理异动】
const purposeByAlarmValidate = async (rule: Rule, value: string) => {
  const { alarmHasMain, fbuPurposeTxt } = form.value
  if (alarmHasMain && fbuPurposeTxt && fbuPurposeTxt !== '处理异动') {
    return Promise.reject(new Error('一二级异动信息存在时，目的只能选择【处理异动】'))
  } else {
    return Promise.resolve()
  }
}
// 处理访客计划数据(只处理详情)
const visitPlanData = computed(() => {
  const { planId, planTitle } = form.value
  const { visitPlanList } = followUpOptions
  if (planId && planTitle && route.query.id) {
    const obj = visitPlanList.find((item: any) => item.id === planId)
    if (!obj) {
      visitPlanList.unshift({
        id: planId,
        title: planTitle,
        disabled: true
      })
    }
  }
  return visitPlanList
})
// 处理商机数据(只处理详情)
const saleChanceData = computed(() => {
  const { chanceId, chanceName, fbuPurposeTxt } = form.value
  const { saleChanceList } = followUpOptions
  // 深耕商机 可以选择5未能合作与6达成合作商机
  let newSaleChanceList = cloneDeep(saleChanceList)
  if (fbuPurposeTxt !== '深耕商机') {
    newSaleChanceList = saleChanceList.filter((v: any) => v.status !== 6 && v.status !== 7 && v.status !== 8)
  }
  if (chanceId && chanceName && (route.query.id || route.query.planId)) {
    const obj = newSaleChanceList.find((item: any) => item.chanceId === chanceId)
    if (!obj) {
      newSaleChanceList.unshift({
        chanceId: chanceId,
        saleChanceName: chanceName,
        disabled: true
      })
    }
  }
  return newSaleChanceList
})
// 目的修改
const changePurpose = (v: string) => {
  nextTick(() => {
    const { fbuPurposeTxt, chanceId } = form.value
    if (fbuPurposeTxt !== '深耕商机' && chanceId) {
      const obj = saleChanceData.value.find((item) => item.chanceId === chanceId)
      if (!obj || (obj && obj.disabled)) {
        form.value.chanceId = undefined
      }
    }
  })
}
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      form.value = v
      resetValue.value = cloneDeep(v)
    }
  },
  { immediate: true }
)
const emit = __emit
// 获取详情
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    followRecordsDetail(route.query.id)
      .then((res) => {
        form.value = {
          ...res.data
        }
        emit('getDetail', res.data)
        resetValue.value = cloneDeep(res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_follow_mode', 'fbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = {
          ...res.data
        }
      } else {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
        paramCodeData.value = {
          ...res.data
        }
      }
    }
  })
}
// 获取跟进记录日期
const getDate = () => {
  followRecordsDate().then((res) => {
    if (res.data) {
      startDate.value = dayjs(res.data)
    }
  })
}
// 获取客户相关信息（访客计划，联系人，商机）
const getMessage = () => {
  if (form.value.followRefId) {
    followRecordsAddByMess({
      followRefId: form.value.followRefId
    }).then((res) => {
      const { contactList, saleChanceList, visitPlanList } = res.data
      followUpOptions.contactList = contactList && contactList.length ? contactList : []
      followUpOptions.saleChanceList = saleChanceList && saleChanceList.length ? saleChanceList : []
      followUpOptions.visitPlanList = visitPlanList && visitPlanList.length ? visitPlanList : []
      // 设置联系人默认值
      if (contactList && contactList.length === 1) {
        if (!form.value.contactId) {
          form.value = {
            ...form.value,
            contactId: contactList[0].id,
            contactName: contactList[0].name
          }
          // resetValue.value = cloneDeep(form.value)
        }
      }
    })
  }
  getSignInList()
}

// 客户修改
const changeCus = (v: any) => {
  form.value = {
    ...form.value,
    followRefId: v,
    contactId: undefined,
    contactName: undefined,
    planId: undefined,
    chanceId: undefined,
    saleChance: {
      ...form.value.saleChance,
      saleChanceRefId: v
    },
    visitPlanList: {
      ...form.value.visitPlanList,
      visitRefId: v,
      chanceId: undefined
    }
  }
}
// 回显数据监听客户名称变化
watch(
  () => form.value.followRefId,
  (val) => {
    if (val) {
      getMessage()
    }
  },
  { immediate: true }
)
watch(
  () => form.value.alarmHasMain,
  (val) => {
    if (val) {
      // 设置默认值
      const purpose: any = paramCodeData.value.fbu_follow_purpose?.find((item: any) => item.cnName === '处理异动')
      if (purpose && (!form.value.fbuPurpose || form.value.fbuPurpose === -9)) {
        form.value.fbuPurpose = purpose.id
        form.value.fbuPurposeTxt = '处理异动'
      }
    }
  },
  { immediate: true }
)
const changeContactId = (v: any, option: any) => {
  form.value.contactName = option ? option.name : undefined
}
// 提交表单
const submitSure = async () => {
  // 处理联系人
  const p = {
    ...form.value,
    saleChance: hasSaleChance.value ? form.value.saleChance : undefined,
    visitPlanList: hasplay.value ? [form.value.visitPlanList] : undefined
  }
  loading.value = true
  try {
    const data = await followRecordsAddOrUpdate(p, { custom: { errorMsg: false } })
    if (data.code === 200) {
      if (route.query.planId) {
        message.success('已完成拜访')
        goBack()
      } else if (route.query.id) {
        message.success('编辑成功')
        goBack()
      } else {
        if (props.archiveIds) {
          potentialArchive({ cosIdList: [props.archiveIds] }).then(() => {
            message.success('新增跟进且置为归档成功')
            goBack()
          })
        } else {
          message.success('新增成功')
          goBack()
        }
      }
    } else if (data.code === 17000016) {
      AModal.warning({
        closable: true,
        title: '操作提示！',
        content: '签约/成交客户至少要有一个商机才能录入跟进记录,是否立即添加？',
        cancelText: '取消',
        okCancel: true,
        okText: '继续',
        onOk() {
          router.push({
            path: '/fbu/business/add',
            query: {
              saleChanceRefId: route.query.followRefId
            }
          })
        }
      })
    } else {
      message.error(data.message)
    }
  } catch (error) {}
  loading.value = false
}

const handleSubmit = async () => {
  const alarmListFromRefVali = alarmListFromRef.value?.validate()
  const baseFormRefVali = baseFormRef.value?.validate()
  const saleChanceFormRefVali = saleChanceFormRef.value?.validate()
  const visitorProgramFormRefVali = visitorProgramFormRef.value?.validate()
  Promise.all([baseFormRefVali, saleChanceFormRefVali, visitorProgramFormRefVali, alarmListFromRefVali]).then(
    async (res) => {
      // 当异动说明选择【已流失】选项时，提交时需弹框提示【已流失客户请及时申请终止合作流程】
      const { alarmProcess } = form.value
      if (alarmProcess && alarmProcess.batch && alarmProcess.batch.length) {
        const hasLast = alarmProcess.batch.find((item: any) => item.alarmDescText?.join('').includes('已流失'))
        if (hasLast) {
          DcConfirm.warning({
            title: '操作提示！',
            content: '已流失客户请及时申请终止合作流程',
            cancelText: '取消',
            okText: '继续',
            onOk() {
              submitSure()
            }
          })
          return
        }
      }
      submitSure()
    }
  )
}

// 重置访客计划、商机表单
const handleReset = () => {
  hasSaleChance.value = false
  hasplay.value = false
  form.value.saleChance = {}
  form.value.visitPlanList = {}
  alarmListFromRef.value?.reset()
}
// 校验访客计划、商机表单
const validate = () => {
  saleChanceFormRef.value?.validate()
  alarmListFromRef.value?.validate()
  visitorProgramFormRef.value?.validate()
}
// 点击新增访客计划
const addVisitPlan = () => {
  hasplay.value = true
  form.value.visitPlanList = {
    visitRefId: form.value.followRefId
  }
}
// 点击新增销售商机
const addSaleChance = () => {
  hasSaleChance.value = true
  form.value.saleChance = {
    saleChanceRefId: form.value.followRefId
  }
}
const init = () => {
  if (route.query.followRefId) {
    form.value = {
      chanceId: route.query.chanceId as string,
      followRefId: route.query.followRefId as string,
      saleChance: {
        saleChanceRefId: route.query.followRefId
      },
      visitPlanList: {
        visitRefId: route.query.followRefId
      }
    }
    resetValue.value = cloneDeep(form.value)
  }
  fetch()
  getByParamCodes()
}
onMounted(() => {
  init()
  getDate()
})
// 缓存
onActivated(() => {
  getMessage()
  getDate()
})

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      name: "detailsForm",
      ref_key: "baseFormRef",
      ref: baseFormRef,
      model: form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, { title: "跟进记录" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "客户名称",
              name: "followRefId",
              rules: [{ required: true, message: '请选择' }]
            }, {
              label: _withCtx(() => [
                _createTextVNode(" 客户名称 "),
                (form.value.preFollowRefName)
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      placement: "top"
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode(" 通过" + _toDisplayString(form.value.preFollowRefName) + "客户合并； ", 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(MessageOutlined), { style: {"margin-left":"4px"} })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(ClueAndCustomerSelect, {
                  appId: "cos_fbu",
                  value: form.value.followRefId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.followRefId) = $event)),
                  label: form.value.customerName,
                  "onUpdate:label": _cache[1] || (_cache[1] = ($event: any) => ((form.value.customerName) = $event)),
                  disabled: __props.disabled || (_unref(route).query.followRefId || _unref(route).query.planId ? true : false),
                  onChange: changeCus,
                  view: __props.view
                }, null, 8, ["value", "label", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "完成访客计划",
              name: "planId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.planId,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.planId) = $event)),
                  fieldNames: {
            label: 'title',
            value: 'id'
          },
                  placeholder: "请选择",
                  options: visitPlanData.value,
                  disabled: __props.disabled || _unref(route).query.planId ? true : false,
                  view: __props.view
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "跟进时间",
              name: "startTime",
              rules: [{ required: true, message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  startTime: form.value.startTime,
                  "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((form.value.startTime) = $event)),
                  endTime: form.value.endTime,
                  "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((form.value.endTime) = $event)),
                  isRange: true,
                  disabled: __props.disabled,
                  view: __props.view,
                  "disabled-date": disabledDate,
                  onChange: getSignInList
                }, null, 8, ["startTime", "endTime", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: "contactId",
              label: "联系人",
              rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.contactId,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.contactId) = $event)),
                  fieldNames: {
            label: 'name',
            value: 'id'
          },
                  allowClear: "",
                  placeholder: "请选择",
                  onChange: changeContactId,
                  options: followUpOptions.contactList,
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "目的",
              name: "fbuPurpose",
              rules: [
          { required: true, validator: _unref(selectForNumberValidate), message: '请选择' },
          {
            validator: purposeByAlarmValidate,
            trigger: 'blur'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.value.fbu_follow_purpose,
                  value: form.value.fbuPurpose,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.fbuPurpose) = $event)),
                  label: form.value.fbuPurposeTxt,
                  "onUpdate:label": _cache[7] || (_cache[7] = ($event: any) => ((form.value.fbuPurposeTxt) = $event)),
                  disabled: __props.disabled,
                  onChange: changePurpose,
                  view: __props.view
                }, null, 8, ["options", "value", "label", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "跟进方式",
              name: "mode",
              rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.value.fbu_follow_mode,
                  label: form.value.fbuFollowTxt,
                  "onUpdate:label": _cache[8] || (_cache[8] = ($event: any) => ((form.value.fbuFollowTxt) = $event)),
                  value: form.value.mode,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.mode) = $event)),
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["options", "label", "value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "关联商机",
              name: "chanceId",
              rules: [
          {
            required: chanceIdRequired.value,
            message: '请选择'
          }
        ]
            }, {
              default: _withCtx(() => [
                (__props.view)
                  ? (_openBlock(), _createBlock(BusinessName, {
                      key: 0,
                      appId: "cos_fbu",
                      value: form.value.chanceName,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.chanceName) = $event))
                    }, null, 8, ["value"]))
                  : (_openBlock(), _createBlock(_component_CosSelect, {
                      key: 1,
                      filterNoVal: "",
                      value: form.value.chanceId,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.value.chanceId) = $event)),
                      allowClear: "",
                      placeholder: "请选择",
                      disabled: __props.disabled,
                      view: __props.view
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(saleChanceData.value, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.chanceId,
                            disabled: item.disabled
                          }, {
                            default: _withCtx(() => [
                              _createVNode(BusinessName, {
                                appId: "cos_fbu",
                                value: item.saleChanceName,
                                "onUpdate:value": ($event: any) => ((item.saleChanceName) = $event)
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            _: 2
                          }, 1032, ["disabled"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "disabled", "view"]))
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              name: "fbuAssistPersons",
              label: "协同人"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_user_select, {
                  value: form.value.fbuAssistPersons,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((form.value.fbuAssistPersons) = $event)),
                  disabled: __props.disabled,
                  mode: "multiple",
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "拜访签到记录",
              name: "signInId",
              rules: [
          {
            required: form.value.fbuFollowTxt === '上门拜访' ? true : false,
            message: '请选择',
            validator: _unref(selectForNumberValidate)
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.signInId,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((form.value.signInId) = $event)),
                  view: __props.view,
                  viewOptions: signInListOptions.value,
                  viewFieldNames: { label: 'signInTime', value: 'id' }
                }, {
                  view: _withCtx(({ option }) => [
                    (option && option.customerAddress)
                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 0,
                          placement: "topLeft",
                          color: "rgba(19, 32, 67, 0.9)"
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString(option.customerAddress), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(option.signInTime || option.id) + " ", 1),
                              _createVNode(_unref(EnvironmentOutlined))
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(option.signInTime || option.id || '--'), 1))
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(signInListOptions.value, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.id,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", {
                            title: item.signInTime
                          }, _toDisplayString(item.signInTime), 9, _hoisted_1),
                          _createElementVNode("p", {
                            title: item.customerAddress,
                            style: {"color":"#999"}
                          }, _toDisplayString(item.customerAddress), 9, _hoisted_2)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "view", "viewOptions"])
              ]),
              _: 1
            }, 8, ["rules"]),
            (__props.disabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_dc_form_item, { label: "跟进人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.dutyByName,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((form.value.dutyByName) = $event)),
                        view: __props.view,
                        placeholder: "请输入",
                        disabled: __props.disabled
                      }, null, 8, ["value", "view", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.createByName,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((form.value.createByName) = $event)),
                        view: __props.view,
                        placeholder: "请输入",
                        disabled: __props.disabled
                      }, null, 8, ["value", "view", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.createTime,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((form.value.createTime) = $event)),
                        view: __props.view,
                        placeholder: "请输入",
                        disabled: __props.disabled
                      }, null, 8, ["value", "view", "disabled"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(AlarmList, {
                  cosId: form.value.followRefId,
                  followId: form.value.id,
                  alarmHasMain: form.value.alarmHasMain,
                  "onUpdate:alarmHasMain": _cache[17] || (_cache[17] = ($event: any) => ((form.value.alarmHasMain) = $event)),
                  value: form.value.alarmProcess,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((form.value.alarmProcess) = $event)),
                  ref_key: "alarmListFromRef",
                  ref: alarmListFromRef,
                  view: __props.view
                }, null, 8, ["cosId", "followId", "alarmHasMain", "value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "具体详情",
              name: "process",
              span: 24,
              rules: [{ required: true, message: '请输入' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Editor), {
                  maxlength: 30000,
                  disabled: __props.disabled,
                  placeholder: editorPlaceholder,
                  value: form.value.process,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((form.value.process) = $event)),
                  mention: form.value.userCodes,
                  "onUpdate:mention": _cache[20] || (_cache[20] = ($event: any) => ((form.value.userCodes) = $event))
                }, null, 8, ["disabled", "value", "mention"])
              ]),
              _: 1
            }),
            (!__props.disabled || form.value.fileId)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  label: "上传附件",
                  name: "fileId",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UploadFile), {
                      disabled: __props.disabled,
                      value: form.value.fileId,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((form.value.fileId) = $event)),
                      valueType: "array",
                      view: __props.view
                    }, null, 8, ["disabled", "value", "view"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_unref(route).path.includes('/fbu/followUpRecord/add') || _unref(route).path.includes('/fbu/followUpRecord/visitingPlan'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      (hasplay.value)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            danger: "",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (hasplay.value = false))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("取消")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            type: "primary",
                            onClick: addVisitPlan,
                            ghost: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("新增")
                            ]),
                            _: 1
                          }))
                    ])
                  ])
                ]),
                (hasplay.value)
                  ? (_openBlock(), _createBlock(VisitorProgramForm, {
                      key: 0,
                      ref_key: "visitorProgramFormRef",
                      ref: visitorProgramFormRef,
                      type: "add",
                      saleChanceRefId: form.value.followRefId || '--',
                      value: form.value.visitPlanList,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((form.value.visitPlanList) = $event))
                    }, null, 8, ["saleChanceRefId", "value"]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    (hasSaleChance.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          danger: "",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (hasSaleChance.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("取消")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          type: "primary",
                          onClick: addSaleChance,
                          ghost: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("新增")
                          ]),
                          _: 1
                        }))
                  ])
                ])
              ]),
              (hasSaleChance.value)
                ? (_openBlock(), _createBlock(BusinessForm, {
                    key: 0,
                    ref_key: "saleChanceFormRef",
                    ref: saleChanceFormRef,
                    type: "add",
                    value: form.value.saleChance,
                    "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((form.value.saleChance) = $event)),
                    saleChanceRefId: form.value.followRefId || '--'
                  }, null, 8, ["value", "saleChanceRefId"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_cos_footer_button, {
          key: 0,
          value: form.value,
          "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((form).value = $event)),
          workCode: form.value.dutyBy,
          formRef: baseFormRef.value,
          resetValue: resetValue.value,
          loading: loading.value,
          onSubmit: handleSubmit,
          onReset: handleReset,
          onValidate: validate,
          disabled: __props.disabled,
          permissionPage: __props.permissionPage
        }, null, 8, ["value", "workCode", "formRef", "resetValue", "loading", "disabled", "permissionPage"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})